/* ------------------------------------------------------------
   Skoop front end helpers
   Loaded once from layout/theme.liquid.

   1. Countdown timer
   2. Shopify Inbox chat button offset
   ------------------------------------------------------------ */

/* ============================================================
   1. Countdown timer
   ============================================================

   Markup: snippets/skoop-countdown.liquid
   Styles: assets/skoop-guarantee.css (section 4)

   Every [data-sk-countdown] element carries its own data-end, an ISO
   timestamp with an explicit UTC offset, so the timer counts down to
   the same real moment no matter what timezone the shopper is in.

   Elements are rendered hidden and only revealed once there is
   confirmed time left. When the clock runs out they hide themselves
   again, so the sale banner and the product page timer both disappear
   on their own without anyone editing the theme.

   Product pages: the theme layout renders the inline timer near the
   top of <main> tagged with data-sk-cd-move, and relocate() drops it
   directly after the price row so it sits below the price and above
   the reviews. Done this way rather than editing the product section
   itself, which Shopify already flags for pre-existing broken HTML. */
(function () {
  if (window.__skoopCountdown) return;
  window.__skoopCountdown = true;

  var TIMER = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function put(el, key, val) {
    var node = el.querySelector('[data-cd-' + key + ']');
    if (node) node.textContent = pad(val);
  }

  function relocate() {
    var movers = document.querySelectorAll('[data-sk-cd-move]');
    for (var i = 0; i < movers.length; i++) {
      var host = movers[i];
      host.removeAttribute('data-sk-cd-move');
      var anchor = document.querySelector('.sk2-pd__pricerow');
      if (!anchor) {
        // No price row on this template. Drop it rather than leave a
        // stray timer floating at the top of the page.
        if (host.parentNode) host.parentNode.removeChild(host);
        continue;
      }
      anchor.insertAdjacentElement('afterend', host);
    }
  }

  function tick() {
    var els = document.querySelectorAll('[data-sk-countdown]');
    if (!els.length) return;

    var now = Date.now();
    var anyLive = false;

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-end') || '');

      if (isNaN(end)) {
        el.hidden = true;
        continue;
      }

      var diff = end - now;

      if (diff <= 0) {
        el.hidden = true;
        continue;
      }

      anyLive = true;

      var total = Math.floor(diff / 1000);
      put(el, 'd', Math.floor(total / 86400));
      put(el, 'h', Math.floor((total % 86400) / 3600));
      put(el, 'm', Math.floor((total % 3600) / 60));
      put(el, 's', total % 60);

      if (el.hidden) el.hidden = false;
    }

    if (!anyLive && TIMER) {
      clearInterval(TIMER);
      TIMER = null;
    }
  }

  function start() {
    relocate();
    tick();
    if (!TIMER) TIMER = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: sections re-render without a page load.
  document.addEventListener('shopify:section:load', function () {
    if (!TIMER) TIMER = setInterval(tick, 1000);
    start();
  });
})();

/* ============================================================
   2. Shopify Inbox chat button offset
   ============================================================

   The Inbox launcher is a <shopify-chat> custom element pinned bottom
   right at z-index 2147483000 (the 32-bit ceiling), with its button
   inside a shadow root. Nothing in the theme can stack above it and no
   stylesheet can reach into it, but the host element is a full viewport
   fixed box with the launcher anchored to its bottom edge, so raising
   the host's bottom raises the button by the same amount.

   assets/skoop-guarantee.css sets two fixed fallback offsets for the
   no JS case. Fixed values on their own are too fragile: the mobile
   sticky add to cart bar changes height with the trust line inside it,
   with font scaling and with the iOS home indicator safe area, so any
   number hard coded there is wrong on some devices.

   This measures instead. Two things have to be accounted for:

     1. The real top edge of the sticky add to cart bar, when it is on
        screen. Read fresh every time it could have moved.
     2. The launcher's OWN offset inside the host. Inbox parks the
        button about 20px above the host's bottom edge (exposed as
        --shopify-agent-activator-offset). Ignoring it stacks the two
        offsets and leaves the button floating well above the thing it
        was only meant to clear, which is what it was doing before.

   So: pick where the button's bottom edge should land, then set the
   host that far up MINUS the launcher's internal offset.

   An earlier CSS :has() version of this was tried and reverted. :has()
   did not reliably re-evaluate when the sticky bar toggled its class
   mid scroll. Do not reintroduce it. */
(function () {
  if (window.__skoopChatOffset) return;
  window.__skoopChatOffset = true;

  // Approximate height of the promo bar that sits on the bottom edge.
  var PROMO = 44;
  // Breathing room between the launcher and whatever is below it.
  var GAP = 8;

  var last = null;

  function launcherInset(chat) {
    // How far the button sits above the host's own bottom edge.
    var nudge =
      chat.shadowRoot && chat.shadowRoot.querySelector('.activator-nudge');
    if (nudge) {
      var v = parseFloat(window.getComputedStyle(nudge).bottom);
      if (!isNaN(v)) return v;
    }
    return 20;
  }

  function apply() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;

    // Where we want the button's bottom edge to land, measured up from
    // the bottom of the viewport.
    var target = PROMO + GAP;

    var bar = document.querySelector('.sk2-pd__sticky');
    if (bar) {
      var rect = bar.getBoundingClientRect();
      var vh = window.innerHeight;
      // Only counts if the bar is actually intruding into the viewport.
      // When it is parked off screen its top sits at or below vh.
      if (rect.height > 0 && rect.top < vh - 4) {
        target = Math.max(target, Math.round(vh - rect.top) + GAP);
      }
    }

    var offset = Math.max(0, Math.round(target - launcherInset(chat)));

    if (offset !== last) {
      last = offset;
      chat.style.setProperty('bottom', offset + 'px', 'important');
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  // Inbox injects <shopify-chat> asynchronously and the sticky bar can
  // change height after fonts load, so keep a slow heartbeat going. One
  // getBoundingClientRect twice a second is not a performance concern.
  setInterval(apply, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
